

<div class="container">
    <div *ngIf="loading()">
        <div class="row">
            <div class="col-12">
                <div class="d-flex justify-content-center">
                    <div class="spinner-border text-primary" role="status" aria-label="Loading">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ng-container *ngIf="!loading()">
        <div class="row mb-3" *ngIf="showDraftToggle() && canEditBip()">
            <div class="col-12 d-flex align-items-center gap-2">
                <p-selectButton [options]="[
            { label: 'Draft', value: false },
            { label: 'Current', value: true }
            ]" [ngModel]="isCurrentView" (onChange)="onIsCurrentViewChange($event)" autoWidth="false"
                    [style]="{ width: '100%', display: 'flex' }" allowEmpty="false">
                </p-selectButton>
                <span class="ms-2">{{ isCurrentView ? 'Viewing Current' : 'Editing Draft' }}</span>
            </div>
        </div>

        <div class="row mb-4" style="color: #222;">
            <div class="col-12">
                @if (!isCurrentView || currentModel) {
                    <article class="sheet" role="document" aria-label="Aggression Behavior Plan">
                        <!-- HEADER -->
                        <header class="sheet-header">
                        <div class="title">
                            <h1>{{selectedBehavior().PatientBehaviorName}}</h1>
                            <small class="muted">Definition &amp; strategies overview</small>
                        </div>
                        <aside class="function" aria-label="Function of Behavior">
                            <div class="head text-center">Function:</div>
                            <ng-container *ngIf="!isCurrentView">
                                <p-multiSelect [options]="functions()" optionLabel="FunctionName" optionValue="ID" [maxSelectedLabels]="4"
                                [(ngModel)]="draftModel!.FunctionIDs" (ngModelChange)="onFunctionIdsChange($event)"
                                display="chip" appendTo="body" [style]="{ width: '100%' }"></p-multiSelect>
                                <div class="function-edit-panel" *ngIf="getDraftFunctionEditItems().length" (click)="$event.stopPropagation()">
                                    <p class="function-edit-hint mb-1" *ngIf="expandedFunctionId == null">Tap a function to mark Primary (P) or Secondary (S)</p>
                                    <div class="function-edit-grid" role="list">
                                        <button type="button" class="function-chip cell {{item.class}}"
                                            *ngFor="let item of getDraftFunctionEditItems()"
                                            [class.is-expanded]="expandedFunctionId === item.functionId"
                                            [class.has-role]="!!item.roleBadge"
                                            [attr.aria-expanded]="expandedFunctionId === item.functionId"
                                            [attr.aria-label]="item.name + (item.roleBadge ? ', ' + item.roleBadge : '')"
                                            (click)="onFunctionChipClick(item.functionId, $event)">
                                            <span class="function-chip-name">{{item.name}}</span>
                                            <span class="role-badge" *ngIf="item.roleBadge && expandedFunctionId !== item.functionId"
                                                [pTooltip]="getRoleTooltip(item.roleBadge)" tooltipPosition="top">{{item.roleBadge}}</span>
                                            <div class="role-pickers" *ngIf="expandedFunctionId === item.functionId">
                                                <button type="button" class="role-btn"
                                                    [class.active]="item.role === 1"
                                                    [pTooltip]="getRoleTooltip('P')"
                                                    tooltipPosition="top"
                                                    (click)="toggleFunctionRole(item.functionId, 1, $event)">P</button>
                                                <button type="button" class="role-btn"
                                                    [class.active]="item.role === 2"
                                                    [pTooltip]="getRoleTooltip('S')"
                                                    tooltipPosition="top"
                                                    (click)="toggleFunctionRole(item.functionId, 2, $event)">S</button>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </ng-container>
                            <div class="grid" role="table" *ngIf="isCurrentView && currentModel">
                                <ng-container *ngFor="let function of getCurrentFunctions()">
                                    <div class="cell {{function.class}}" role="cell">
                                        <span class="role-badge role-badge--readonly" *ngIf="getRoleBadgeForDisplay(function.roleLabel) as roleBadge"
                                            [pTooltip]="getRoleTooltip(roleBadge)" tooltipPosition="top">{{roleBadge}}</span>
                                        <span>{{function.name}}</span>
                                    </div>
                                </ng-container>
                            </div>
                        </aside>
                        </header>
                    
                        <!-- DEFINITION -->
                        <section class="section">
                        <div class="panel bg-yellow">
                            <h3 class="pillhead bg-yellow-2">Definition</h3>
                            <div *ngIf="!isCurrentView">
                                <ckeditor
                                [attr.id]="editorId('definition')"
                                [attr.name]="editorId('definition')"
                                [editor]="Editor"
                                [config]="editorConfig"
                                [(ngModel)]="draftModel!.Definition"
                                [ngModelOptions]="{standalone:true}"
                                ></ckeditor>
                            </div>
                            <p *ngIf="isCurrentView && currentModel"><span [innerHTML]="currentModel.Definition| safeHtml"></span></p>
                        </div>
                        </section>
                    
                        <!-- CONTEXT / PRECURSORS -->
                        <section class="section two-col">
                        <div class="panel bg-blue-2">
                            <span class="pillhead bg-blue-3">Context</span>
                            <div *ngIf="!isCurrentView">
                                <ckeditor
                                [attr.id]="editorId('context')"
                                [attr.name]="editorId('context')"
                                [editor]="Editor"
                                [config]="editorConfig"
                                [(ngModel)]="draftModel!.Context"
                                [ngModelOptions]="{standalone:true}"
                                ></ckeditor>
                            </div>
                            <p *ngIf="isCurrentView && currentModel"><span [innerHTML]="currentModel.Context| safeHtml"></span></p>
                        </div>
                        <div class="panel bg-blue">
                            <span class="pillhead bg-blue-4">Precursors</span>
                            <div *ngIf="!isCurrentView">
                                <ckeditor
                                [attr.id]="editorId('precursors')"
                                [attr.name]="editorId('precursors')"
                                [editor]="Editor"
                                [config]="editorConfig"
                                [(ngModel)]="draftModel!.Precursors"
                                [ngModelOptions]="{standalone:true}"
                                ></ckeditor>
                            </div>
                            <p *ngIf="isCurrentView && currentModel"><span [innerHTML]="currentModel.Precursors| safeHtml"></span></p>
                        </div>
                        </section>
                    
                        <!-- ANTECEDENT STRATEGIES -->
                        <section class="section">
                        <div class="panel bg-green">
                            <h3 class="pillhead bg-green-2">Antecedent Strategies (A)</h3>

                            <ng-container *ngIf="isCurrentView && currentModel">
                                <div *ngFor="let antecedent of currentModel.Antecedents" [attr.id]="strategyAnchor('A', antecedent)">
                                    <p><strong>{{antecedent.Name}}</strong>:</p>
                                    <p><span [innerHTML]="antecedent.Description| safeHtml"></span></p>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="!isCurrentView">
                                <div *ngFor="let row of antecedentRows(); let i = index; trackBy: trackByStrategyRow" [attr.id]="strategyAnchor('A', { ID: row.id, Name: (row.customName && row.name.toLowerCase() === 'other') ? row.customName : row.name })">
                                    
                                    <button class="btn btn-link text-danger p-0 float-end" (click)="removeAntecedentRow(i)">
                                        <i class="pi pi-trash"></i>
                                    </button>
                                    <p style="font-weight: bold;">
                                    <ng-container >
                                        <p-dropdown [options]="availableAntecedentTemplates(i)" optionLabel="Name" optionValue="Name"
                                        [(ngModel)]="row.name"
                                        [ngModelOptions]="{standalone:true}"
                                        (onChange)="onAntecedentTemplateChange(i, $event.value)"
                                        [style]="{width:'100%'}"
                                        appendTo="body"
                                        [class.is-invalid]="antecedentNameInvalid(i)"
                                    ></p-dropdown>
                                    <input *ngIf="(row.name || '').toLowerCase()==='other'"
                                    type="text" class="form-control mt-2" placeholder="Enter strategy name"
                                    [(ngModel)]="row.customName"
                                    [ngModelOptions]="{standalone:true}"
                                    [class.is-invalid]="antecedentOtherInvalid(i)" />
                                    
                                    </ng-container>
                                </p>
                                    <div>
                                        <ckeditor
                                        [attr.id]="editorId('antecedent-description', row)"
                                        [attr.name]="editorId('antecedent-description', row)"
                                        [editor]="Editor"
                                        [config]="editorConfig"
                                        [(ngModel)]="row.description"
                                        [ngModelOptions]="{standalone:true}"
                                        ></ckeditor>
                                    </div>
                                </div>
                                <button class="btn btn-sm btn-outline-primary" *ngIf="!addingAntecedent" (click)="addAntecedentRow()">Add</button>
                                <div *ngIf="addingAntecedent" class="spinner-border text-primary" role="status" aria-label="Adding..."></div>
                            </ng-container>
                    
                            
                        </div>
                        </section>
                    
                        <section class="section">
                            <div class="panel bg-orange">
                            <h3 class="pillhead bg-orange-2">Replacement Strategies (R)</h3>
                            <ng-container *ngIf="isCurrentView && currentModel">
                                <div *ngFor="let replacement of currentModel.Replacements" [attr.id]="strategyAnchor('R', replacement)">
                                <p><strong>{{replacement.Name}}</strong>:</p>
                                <p><span [innerHTML]="replacement.Description| safeHtml"></span></p>
                            </div>
                            </ng-container>
                            <ng-container *ngIf="!isCurrentView">
                                <div *ngFor="let row of replacementRows(); let i = index; trackBy: trackByStrategyRow" [attr.id]="strategyAnchor('R', { ID: row.id, Name: (row.customName && row.name.toLowerCase() === 'other') ? row.customName : row.name })">
                                    <button class="btn btn-link text-danger p-0 float-end" (click)="removeReplacementRow(i)">
                                        <i class="pi pi-trash"></i>
                                    </button>
                                    <p style="font-weight: bold;">
                                        <ng-container>
                                            <p-dropdown [options]="availableReplacementTemplates(i)" optionLabel="Name" optionValue="Name"
                                        [(ngModel)]="row.name"
                                        [ngModelOptions]="{standalone:true}"
                                        (onChange)="onReplacementTemplateChange(i, $event.value)"
                                        [style]="{width:'100%'}"
                                        appendTo="body"
                                        [class.is-invalid]="replacementNameInvalid(i)"
                                    ></p-dropdown>
                                    <input *ngIf="(row.name || '').toLowerCase()==='other'"
                                        type="text" class="form-control mt-2" placeholder="Enter replacement name"
                                        [(ngModel)]="row.customName"
                                        [ngModelOptions]="{standalone:true}"
                                        [class.is-invalid]="replacementOtherInvalid(i)" />
                                    </ng-container>
                                </p>
                                    <div>
                                        <ckeditor
                                        [attr.id]="editorId('replacement-description', row)"
                                        [attr.name]="editorId('replacement-description', row)"
                                        [editor]="Editor"
                                        [config]="editorConfig"
                                        [(ngModel)]="row.description"
                                        [ngModelOptions]="{standalone:true}"
                                        ></ckeditor>
                                    </div>
                                </div>
                                <button class="btn btn-sm btn-outline-primary" *ngIf="!addingReplacement" (click)="addReplacementRow()">Add</button>
                                <div *ngIf="addingReplacement" class="spinner-border text-primary" role="status" aria-label="Adding..."></div>
                            </ng-container>
                    
                            
                            
                            </div>  
                        </section>
                    
                        <!-- CONSEQUENCES -->
                    
                        <section class="section">
                            <div class="panel bg-red">
                            <h3 class="pillhead bg-red-2">Consequence Strategies (R)</h3>
                            <ng-container *ngIf="isCurrentView && currentModel">
                            <div *ngFor="let consequence of currentModel.Consequences" [attr.id]="strategyAnchor('C', consequence)">
                                <p><strong>{{consequence.Name}}</strong>:</p>
                                <p><span [innerHTML]="consequence.Description| safeHtml"></span></p>
                            </div>
                            </ng-container>
                            <ng-container *ngIf="!isCurrentView">
                                    <div *ngFor="let row of consequenceRows(); let i = index; trackBy: trackByStrategyRow" [attr.id]="strategyAnchor('C', { ID: row.id, Name: (row.customName && row.name.toLowerCase() === 'other') ? row.customName : row.name })">
                                    <button class="btn btn-link text-danger p-0 float-end" (click)="removeConsequenceRow(i)">
                                        <i class="pi pi-trash"></i>
                                    </button>
                                    <p style="font-weight: bold;">
                                        <ng-container>
                                            <p-dropdown [options]="availableConsequenceTemplates(i)" optionLabel="Name" optionValue="Name"
                                        [(ngModel)]="row.name"
                                        [ngModelOptions]="{standalone:true}"
                                        (onChange)="onConsequenceTemplateChange(i, $event.value)"
                                        [style]="{width:'100%'}"
                                        appendTo="body"
                                        [class.is-invalid]="consequenceNameInvalid(i)"
                                    ></p-dropdown>
                                    <input *ngIf="(row.name || '').toLowerCase()==='other'"
                                        type="text" class="form-control mt-2" placeholder="Enter consequence name"
                                        [(ngModel)]="row.customName"
                                        [ngModelOptions]="{standalone:true}"
                                        [class.is-invalid]="consequenceOtherInvalid(i)" />
                                    </ng-container>
                                </p>
                                    <div>
                                        <ckeditor
                                        [attr.id]="editorId('consequence-description', row)"
                                        [attr.name]="editorId('consequence-description', row)"
                                        [editor]="Editor"
                                        [config]="editorConfig"
                                        [(ngModel)]="row.description"
                                        [ngModelOptions]="{standalone:true}"
                                        ></ckeditor>
                                    </div>
                                </div>
                                <button class="btn btn-sm btn-outline-primary" *ngIf="!addingConsequence" (click)="addConsequenceRow()">Add</button>
                                <div *ngIf="addingConsequence" class="spinner-border text-primary" role="status" aria-label="Adding..."></div>
                            </ng-container>
                            </div>  
                        </section>
                    </article>
                    }
                @if (isCurrentView && !currentModel) {
                    <article class="sheet" role="document" aria-label="Aggression Behavior Plan">
                        <!-- HEADER -->
                        <header class="sheet-header">
                        <div class="title">
                            <h1>{{selectedBehavior().PatientBehaviorName}}</h1>
                            <small class="muted">Definition &amp; strategies overview</small>
                        </div>
                        </header>
                        <div class="alert alert-info m-5" role="alert">No current BIP info for this behavior.</div>
                    </article>
                }
            </div>
        </div>
        
        <div class="col-12 text-end" *ngIf="!isCurrentView && showSaveButton() && canEditBip()">
            <div class="text-danger small mb-2" *ngIf="showValidationMessage">Please complete all required fields before saving.</div>
            <button class="side-menu-button2" (click)="save()" [disabled]="!draftModel">Save Draft</button>
        </div>
    </ng-container>
</div>
